/* GuideGxP image viewer, 2026-09-05. Image-only galleries; native video/3D fallback. */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() { super(); this.gxpZoomed = false; }
      hide() {
        super.hide();
        if (this.gxpObserver) this.gxpObserver.disconnect();
        this.gxpZoomed = false;
      }
      show(opener) {
        this.initGxpViewer();
        super.show(opener);
        this.showActiveMedia();
        if (this.gxpObserver) this.gxpObserver.observe(this.gxpContent);
      }
      showActiveMedia() {
        if (this.gxpImages) {
          const id = this.openedBy.getAttribute('data-media-id');
          const index = this.gxpImages.findIndex((image) => image.dataset.mediaId === id);
          this.selectGxpImage(index < 0 ? 0 : index);
          return;
        }
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => element.classList.remove('active'));
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
      }
      initGxpViewer() {
        if (this.gxpImages) return;
        const content = this.querySelector('.product-media-modal__content');
        const dialog = this.querySelector('[role="dialog"]');
        const close = this.querySelector('[id^="ModalClose-"]');
        const media = content ? Array.from(content.children) : [];
        if (!dialog || !close || !media.length || media.some((item) => item.tagName !== 'IMG')) return;
        const translations = {
          it: { title: 'Anteprima della guida', image: 'Immagine', of: 'di', zoom: 'Ingrandisci', fit: 'Adatta allo schermo', previous: 'Immagine precedente', next: 'Immagine successiva', close: 'Chiudi anteprima', hint: 'Ingrandisci per leggere i dettagli.', zoomHint: 'Scorri per esplorare. Riduci per vedere tutto.' },
          en: { title: 'Guide preview', image: 'Image', of: 'of', zoom: 'Zoom in', fit: 'Fit to screen', previous: 'Previous image', next: 'Next image', close: 'Close preview', hint: 'Zoom in to read the details.', zoomHint: 'Scroll to explore. Zoom out to see everything.' },
          de: { title: 'Vorschau des Leitfadens', image: 'Bild', of: 'von', zoom: 'Vergrößern', fit: 'An Bildschirm anpassen', previous: 'Vorheriges Bild', next: 'Nächstes Bild', close: 'Vorschau schließen', hint: 'Vergrößern, um Details zu lesen.', zoomHint: 'Zum Erkunden scrollen. Für die Gesamtansicht verkleinern.' },
          fr: { title: 'Aperçu du guide', image: 'Image', of: 'sur', zoom: 'Agrandir', fit: 'Adapter à l’écran', previous: 'Image précédente', next: 'Image suivante', close: 'Fermer l’aperçu', hint: 'Agrandissez pour lire les détails.', zoomHint: 'Faites défiler pour explorer. Réduisez pour tout voir.' },
          es: { title: 'Vista previa de la guía', image: 'Imagen', of: 'de', zoom: 'Ampliar', fit: 'Ajustar a la pantalla', previous: 'Imagen anterior', next: 'Imagen siguiente', close: 'Cerrar vista previa', hint: 'Amplía para leer los detalles.', zoomHint: 'Desplázate para explorar. Reduce para verlo todo.' }
        };
        const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        this.gxpText = translations[language] || translations.en;
        this.gxpImages = media;
        this.gxpContent = content;
        this.installGxpStyles();
        const toolbar = document.createElement('div');
        toolbar.className = 'gxp-lb__toolbar';
        const heading = document.createElement('div');
        heading.className = 'gxp-lb__heading';
        const title = document.createElement('strong');
        title.textContent = this.gxpText.title;
        this.gxpCounter = document.createElement('span');
        this.gxpCounter.setAttribute('role', 'status');
        this.gxpCounter.setAttribute('aria-live', 'polite');
        this.gxpCounter.setAttribute('aria-atomic', 'true');
        heading.append(title, this.gxpCounter);
        this.gxpZoom = this.makeGxpButton(this.gxpText.zoom, '+');
        this.gxpZoom.classList.add('gxp-lb__zoom');
        this.gxpZoom.setAttribute('aria-pressed', 'false');
        this.gxpZoomText = document.createElement('span');
        this.gxpZoomText.className = 'gxp-lb__zoom-text';
        this.gxpZoom.appendChild(this.gxpZoomText);
        this.gxpZoom.addEventListener('click', () => this.toggleGxpZoom());
        close.setAttribute('aria-label', this.gxpText.close);
        close.setAttribute('title', this.gxpText.close);
        toolbar.append(heading, this.gxpZoom, close);
        const canvas = document.createElement('div');
        canvas.className = 'gxp-lb__canvas';
        media.forEach((image) => {
          canvas.appendChild(image);
          image.addEventListener('load', () => this.fitGxpImage());
          image.addEventListener('click', () => this.toggleGxpZoom());
        });
        content.appendChild(canvas);
        const footer = document.createElement('div');
        footer.className = 'gxp-lb__footer';
        this.gxpPrevious = this.makeGxpButton(this.gxpText.previous, '←');
        this.gxpNext = this.makeGxpButton(this.gxpText.next, '→');
        this.gxpHint = document.createElement('span');
        this.gxpHint.className = 'gxp-lb__hint';
        this.gxpPrevious.addEventListener('click', () => this.selectGxpImage(this.gxpIndex - 1));
        this.gxpNext.addEventListener('click', () => this.selectGxpImage(this.gxpIndex + 1));
        this.gxpPrevious.hidden = this.gxpNext.hidden = media.length < 2;
        footer.append(this.gxpPrevious, this.gxpHint, this.gxpNext);
        dialog.prepend(toolbar);
        dialog.appendChild(footer);
        // Keep native Escape, close-button, focus restoration and backdrop behavior.
        dialog.addEventListener('pointerup', (event) => event.stopPropagation());
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open') || this.gxpZoomed || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.selectGxpImage(this.gxpIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        this.classList.add('gxp-lb');
        this.gxpObserver = new ResizeObserver(() => this.fitGxpImage());
      }
      makeGxpButton(label, symbol) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gxp-lb__button';
        button.setAttribute('aria-label', label);
        button.title = label;
        const icon = document.createElement('span');
        icon.className = 'gxp-lb__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = symbol;
        button.appendChild(icon);
        return button;
      }
      selectGxpImage(index) {
        this.gxpIndex = (index + this.gxpImages.length) % this.gxpImages.length;
        this.gxpZoomed = false;
        this.gxpImages.forEach((image, current) => {
          image.classList.toggle('active', current === this.gxpIndex);
          image.hidden = current !== this.gxpIndex;
        });
        const t = this.gxpText;
        this.gxpCounter.textContent = `${t.image} ${this.gxpIndex + 1} ${t.of} ${this.gxpImages.length}`;
        this.fitGxpImage();
        this.gxpContent.scrollTo(0, 0);
      }
      toggleGxpZoom() {
        if (this.gxpZoom.disabled) return;
        this.gxpZoomed = !this.gxpZoomed;
        this.fitGxpImage();
        this.gxpContent.scrollTo(Math.max(0, (this.gxpContent.scrollWidth - this.gxpContent.clientWidth) / 2), 0);
      }
      fitGxpImage() {
        if (!this.gxpImages || !this.hasAttribute('open')) return;
        const image = this.gxpImages[this.gxpIndex];
        if (!image) return;
        const candidates = Array.from(image.srcset.matchAll(/\s(\d+)w(?:\s*,|\s*$)/g), (match) => Number(match[1]));
        const originalWidth = Math.max(...candidates, image.naturalWidth || Number(image.getAttribute('width')) || 1100);
        const ratio = image.naturalWidth && image.naturalHeight ? image.naturalHeight / image.naturalWidth : (Number(image.getAttribute('height')) || 1100) / (Number(image.getAttribute('width')) || 1100);
        const availableWidth = Math.max(1, this.gxpContent.clientWidth - 32);
        const availableHeight = Math.max(1, this.gxpContent.clientHeight - 32);
        const fittedWidth = Math.min(originalWidth, availableWidth, availableHeight / ratio);
        const width = this.gxpZoomed ? originalWidth : fittedWidth;
        image.style.setProperty('--gxp-image-width', `${Math.floor(width)}px`);
        image.style.setProperty('--gxp-image-height', `${Math.floor(width * ratio)}px`);
        const sizes = `${Math.ceil(width)}px`;
        if (image.sizes !== sizes) image.sizes = sizes;
        this.classList.toggle('gxp-lb--zoomed', this.gxpZoomed);
        const label = this.gxpZoomed ? this.gxpText.fit : this.gxpText.zoom;
        this.gxpZoom.disabled = !this.gxpZoomed && fittedWidth >= originalWidth - 1;
        this.gxpZoom.setAttribute('aria-label', label);
        this.gxpZoom.setAttribute('aria-pressed', String(this.gxpZoomed));
        this.gxpZoom.title = label;
        this.gxpZoomText.textContent = label;
        this.gxpZoom.querySelector('.gxp-lb__icon').textContent = this.gxpZoomed ? '−' : '+';
        this.gxpHint.textContent = this.gxpZoomed ? this.gxpText.zoomHint : this.gxpText.hint;
      }
      installGxpStyles() {
        if (document.getElementById('gxp-product-lightbox-styles')) return;
        const style = document.createElement('style');
        style.id = 'gxp-product-lightbox-styles';
        style.textContent = `
          product-modal.gxp-lb { background: rgba(7,31,53,.86); box-sizing: border-box; overflow: hidden; }
          product-modal.gxp-lb[open] { display: flex; align-items: center; justify-content: center; padding: 24px; }
          product-modal.gxp-lb .product-media-modal__dialog {
            position: relative; inset: auto; display: flex; flex-direction: column; align-items: stretch;
            width: min(1240px,100%); height: calc(100vh - 48px); height: calc(100dvh - 48px);
            max-height: 1000px; min-height: 0; margin: 0; padding: 0; overflow: hidden;
            border: 1px solid #c7e4ee; border-radius: 18px; background: #f1f7fa;
            box-shadow: 0 24px 80px rgba(0,0,0,.28); color: #104a7d; outline: none;
            font-family: var(--font-body-family, sans-serif); letter-spacing: normal;
          }
          product-modal.gxp-lb .gxp-lb__toolbar {
            display: flex; align-items: center; gap: 16px; flex: 0 0 auto;
            min-height: 76px; padding: 12px 20px; background: #fff; border-bottom: 1px solid #d6e7ee;
          }
          product-modal.gxp-lb .gxp-lb__heading { flex: 1; min-width: 0; line-height: 1.4; }
          product-modal.gxp-lb .gxp-lb__heading strong { display: block; font-size: 17px; font-weight: 700; }
          product-modal.gxp-lb .gxp-lb__heading > span { display: block; font-size: 13px; color: #526a7e; margin-top: 2px; }
          product-modal.gxp-lb .product-media-modal__content {
            display: block; position: relative; flex: 1 1 0; min-height: 0; height: auto;
            width: 100%; max-width: none; margin: 0; padding: 0; overflow: auto;
            background: #f1f7fa; overscroll-behavior: contain; scroll-behavior: auto;
          }
          product-modal.gxp-lb .gxp-lb__canvas {
            display: flex; align-items: center; justify-content: center;
            width: max-content; min-width: 100%; min-height: 100%; padding: 16px; box-sizing: border-box;
          }
          product-modal.gxp-lb .gxp-lb__canvas > img { display: none !important; }
          product-modal.gxp-lb .gxp-lb__canvas > img.active {
            display: block !important; flex: none; width: var(--gxp-image-width) !important;
            height: var(--gxp-image-height) !important; min-width: 0; min-height: 0;
            max-width: none !important; max-height: none !important; margin: 0; padding: 0;
            border: 0; border-radius: 4px; object-fit: contain; cursor: zoom-in;
            box-shadow: 0 4px 24px rgba(14,58,89,.09);
          }
          product-modal.gxp-lb--zoomed .gxp-lb__canvas > img.active { cursor: zoom-out; }
          product-modal.gxp-lb .gxp-lb__footer {
            display: flex; align-items: center; justify-content: space-between; gap: 16px;
            flex: 0 0 auto; min-height: 68px; padding: 10px 20px;
            background: #fff; border-top: 1px solid #d6e7ee;
          }
          product-modal.gxp-lb .gxp-lb__hint { flex: 1; text-align: center; font-size: 13px; line-height: 1.5; color: #526a7e; }
          product-modal.gxp-lb .gxp-lb__button,
          product-modal.gxp-lb .product-media-modal__toggle {
            position: static; transform: none; margin: 0; flex: 0 0 auto;
            display: inline-flex; align-items: center; justify-content: center; gap: 8px;
            width: 44px; height: 44px; min-width: 44px; min-height: 44px;
            padding: 0; border: 1px solid #c7e4ee; border-radius: 50%;
            background: #fff; color: #104a7d; opacity: 1; cursor: pointer;
            box-shadow: none; font: inherit; font-size: 14px; line-height: 1;
          }
          product-modal.gxp-lb .gxp-lb__button:hover,
          product-modal.gxp-lb .product-media-modal__toggle:hover { background: #e6f5f9; border-color: #118aa8; }
          product-modal.gxp-lb .gxp-lb__button:focus-visible,
          product-modal.gxp-lb .product-media-modal__toggle:focus-visible,
          product-modal.gxp-lb .product-media-modal__content:focus-visible { outline: 3px solid #0f8ba9; outline-offset: -3px; }
          product-modal.gxp-lb .gxp-lb__button[hidden] { display: none; }
          product-modal.gxp-lb .gxp-lb__button:disabled { opacity: .5; cursor: default; }
          product-modal.gxp-lb .gxp-lb__zoom { width: auto; padding: 0 16px; border-radius: 24px; background: #104a7d; border-color: #104a7d; color: #fff; }
          product-modal.gxp-lb .gxp-lb__zoom:hover { background: #096e91; color: #fff; }
          product-modal.gxp-lb .gxp-lb__icon { font: 25px/1 Arial,sans-serif; }
          product-modal.gxp-lb .product-media-modal__toggle svg { width: 16px; height: 16px; }
          @media (max-width: 600px) {
            product-modal.gxp-lb[open] { padding: 8px; }
            product-modal.gxp-lb .product-media-modal__dialog { height: calc(100vh - 16px); height: calc(100dvh - 16px); border-radius: 12px; }
            product-modal.gxp-lb .gxp-lb__toolbar { padding: 10px 12px; gap: 8px; min-height: 72px; }
            product-modal.gxp-lb .gxp-lb__heading strong { font-size: 15px; }
            product-modal.gxp-lb .gxp-lb__zoom { width: 44px; padding: 0; }
            product-modal.gxp-lb .gxp-lb__zoom-text { display: none; }
            product-modal.gxp-lb .gxp-lb__footer { padding: 10px 12px; gap: 10px; }
            product-modal.gxp-lb .gxp-lb__hint { font-size: 12px; }
          }
        `;
        document.head.appendChild(style);
      }
    }
  );
}
